import { render, staticRenderFns } from "./PatrimonyTracking.vue?vue&type=template&id=23806d8a&scoped=true&"
import script from "./PatrimonyTracking.vue?vue&type=script&lang=js&"
export * from "./PatrimonyTracking.vue?vue&type=script&lang=js&"
import style0 from "./PatrimonyTracking.vue?vue&type=style&index=0&id=23806d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23806d8a",
  null
  
)

export default component.exports